/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type PreOpsAnswer,
    PreOpsAnswerFromJSON,
    PreOpsAnswerToJSON,
} from '../models/PreOpsAnswer';
import {
    type PreOpsAnswerChoice,
    PreOpsAnswerChoiceFromJSON,
    PreOpsAnswerChoiceToJSON,
} from '../models/PreOpsAnswerChoice';
import {
    type PreOpsAnswerGroupCreate,
    PreOpsAnswerGroupCreateFromJSON,
    PreOpsAnswerGroupCreateToJSON,
} from '../models/PreOpsAnswerGroupCreate';
import {
    type PreOpsAnswerSortKey,
    PreOpsAnswerSortKeyFromJSON,
    PreOpsAnswerSortKeyToJSON,
} from '../models/PreOpsAnswerSortKey';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';

export interface PreOpsAnswersCreatePreOpsAnswerGroupRequest {
    preOpsAnswerGroupCreate: PreOpsAnswerGroupCreate;
}

export interface PreOpsAnswersExportPreOpsAnswersListRequest {
    timezone: string;
    exportType: PreOpsAnswersExportPreOpsAnswersListExportType;
    pageSize: number;
    dateStart?: Date;
    dateEnd?: Date;
    choices?: Array<PreOpsAnswerChoice> | null;
    vehicleIds?: Array<string> | null;
    questionId?: string | null;
    answerGroupId?: string | null;
    checklistId?: string | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: PreOpsAnswerSortKey;
}

export interface PreOpsAnswersListPreOpsAnswersRequest {
    pageSize: number;
    dateStart?: Date;
    dateEnd?: Date;
    choices?: Array<PreOpsAnswerChoice> | null;
    vehicleIds?: Array<string> | null;
    questionId?: string | null;
    answerGroupId?: string | null;
    checklistId?: string | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: PreOpsAnswerSortKey;
}

export interface PreOpsAnswersListPreOpsAnswersMetadataRequest {
    pageSize: number;
    dateStart?: Date;
    dateEnd?: Date;
    choices?: Array<PreOpsAnswerChoice> | null;
    vehicleIds?: Array<string> | null;
    questionId?: string | null;
    answerGroupId?: string | null;
    checklistId?: string | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: PreOpsAnswerSortKey;
}

export interface PreOpsAnswersReadPreOpsAnswerRequest {
    answerId: string;
}

export interface PreOpsAnswersValidatePreOpsAnswerGroupRequest {
    preOpsAnswerGroupCreate: PreOpsAnswerGroupCreate;
}

/**
 * PreOpsAnswersApi - interface
 * 
 * @export
 * @interface PreOpsAnswersApiInterface
 */
export interface PreOpsAnswersApiInterface {
    /**
     * Creates request options for preOpsAnswersCreatePreOpsAnswerGroup without sending the request
     * @param {PreOpsAnswerGroupCreate} preOpsAnswerGroupCreate 
     * @throws {RequiredError}
     * @memberof PreOpsAnswersApiInterface
     */
    preOpsAnswersCreatePreOpsAnswerGroupRequestOpts(requestParameters: PreOpsAnswersCreatePreOpsAnswerGroupRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new pre-ops answer group.
     * @summary Create a pre-ops answer group
     * @param {PreOpsAnswerGroupCreate} preOpsAnswerGroupCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreOpsAnswersApiInterface
     */
    preOpsAnswersCreatePreOpsAnswerGroupRaw(requestParameters: PreOpsAnswersCreatePreOpsAnswerGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PreOpsAnswer>>>;

    /**
     * Create a new pre-ops answer group.
     * Create a pre-ops answer group
     */
    preOpsAnswersCreatePreOpsAnswerGroup(requestParameters: PreOpsAnswersCreatePreOpsAnswerGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PreOpsAnswer>>;

    /**
     * Creates request options for preOpsAnswersExportPreOpsAnswersList without sending the request
     * @param {string} timezone 
     * @param {'csv' | 'xlsx'} exportType 
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {Array<PreOpsAnswerChoice>} [choices] 
     * @param {Array<string>} [vehicleIds] 
     * @param {string} [questionId] 
     * @param {string} [answerGroupId] 
     * @param {string} [checklistId] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {PreOpsAnswerSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof PreOpsAnswersApiInterface
     */
    preOpsAnswersExportPreOpsAnswersListRequestOpts(requestParameters: PreOpsAnswersExportPreOpsAnswersListRequest): Promise<runtime.RequestOpts>;

    /**
     * Exports all the answers present.  If `search` is specified, return values similar to the `label` field. In that case, `sortKey` will not have any effect. I.e. results will be sorted by similarity to the search term instead.  Optionally filter by answer choice, question ID, answer group ID, create date and checklist ID. The `date_start` parameter is inclusive, the `date_end` parameter is exclusive.
     * @summary Export pre-ops answers as csv or xlsx
     * @param {string} timezone 
     * @param {'csv' | 'xlsx'} exportType 
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {Array<PreOpsAnswerChoice>} [choices] 
     * @param {Array<string>} [vehicleIds] 
     * @param {string} [questionId] 
     * @param {string} [answerGroupId] 
     * @param {string} [checklistId] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {PreOpsAnswerSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreOpsAnswersApiInterface
     */
    preOpsAnswersExportPreOpsAnswersListRaw(requestParameters: PreOpsAnswersExportPreOpsAnswersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Exports all the answers present.  If `search` is specified, return values similar to the `label` field. In that case, `sortKey` will not have any effect. I.e. results will be sorted by similarity to the search term instead.  Optionally filter by answer choice, question ID, answer group ID, create date and checklist ID. The `date_start` parameter is inclusive, the `date_end` parameter is exclusive.
     * Export pre-ops answers as csv or xlsx
     */
    preOpsAnswersExportPreOpsAnswersList(requestParameters: PreOpsAnswersExportPreOpsAnswersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * Creates request options for preOpsAnswersListPreOpsAnswers without sending the request
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {Array<PreOpsAnswerChoice>} [choices] 
     * @param {Array<string>} [vehicleIds] 
     * @param {string} [questionId] 
     * @param {string} [answerGroupId] 
     * @param {string} [checklistId] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {PreOpsAnswerSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof PreOpsAnswersApiInterface
     */
    preOpsAnswersListPreOpsAnswersRequestOpts(requestParameters: PreOpsAnswersListPreOpsAnswersRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the answers present.  If `search` is specified, return values similar to the `label` field. In that case, `sortKey` will not have any effect. I.e. results will be sorted by similarity to the search term instead.  Optionally filter by answer choice, question ID, answer group ID, create date, and checklist ID. The `date_start` parameter is inclusive, the `date_end` parameter is exclusive.
     * @summary List pre-ops answers
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {Array<PreOpsAnswerChoice>} [choices] 
     * @param {Array<string>} [vehicleIds] 
     * @param {string} [questionId] 
     * @param {string} [answerGroupId] 
     * @param {string} [checklistId] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {PreOpsAnswerSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreOpsAnswersApiInterface
     */
    preOpsAnswersListPreOpsAnswersRaw(requestParameters: PreOpsAnswersListPreOpsAnswersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PreOpsAnswer>>>;

    /**
     * Lists all the answers present.  If `search` is specified, return values similar to the `label` field. In that case, `sortKey` will not have any effect. I.e. results will be sorted by similarity to the search term instead.  Optionally filter by answer choice, question ID, answer group ID, create date, and checklist ID. The `date_start` parameter is inclusive, the `date_end` parameter is exclusive.
     * List pre-ops answers
     */
    preOpsAnswersListPreOpsAnswers(requestParameters: PreOpsAnswersListPreOpsAnswersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PreOpsAnswer>>;

    /**
     * Creates request options for preOpsAnswersListPreOpsAnswersMetadata without sending the request
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {Array<PreOpsAnswerChoice>} [choices] 
     * @param {Array<string>} [vehicleIds] 
     * @param {string} [questionId] 
     * @param {string} [answerGroupId] 
     * @param {string} [checklistId] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {PreOpsAnswerSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof PreOpsAnswersApiInterface
     */
    preOpsAnswersListPreOpsAnswersMetadataRequestOpts(requestParameters: PreOpsAnswersListPreOpsAnswersMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary Pre-ops answer listing metadata
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {Array<PreOpsAnswerChoice>} [choices] 
     * @param {Array<string>} [vehicleIds] 
     * @param {string} [questionId] 
     * @param {string} [answerGroupId] 
     * @param {string} [checklistId] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {PreOpsAnswerSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreOpsAnswersApiInterface
     */
    preOpsAnswersListPreOpsAnswersMetadataRaw(requestParameters: PreOpsAnswersListPreOpsAnswersMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * Pre-ops answer listing metadata
     */
    preOpsAnswersListPreOpsAnswersMetadata(requestParameters: PreOpsAnswersListPreOpsAnswersMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for preOpsAnswersReadPreOpsAnswer without sending the request
     * @param {string} answerId 
     * @throws {RequiredError}
     * @memberof PreOpsAnswersApiInterface
     */
    preOpsAnswersReadPreOpsAnswerRequestOpts(requestParameters: PreOpsAnswersReadPreOpsAnswerRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the answer specified by the given ID.
     * @summary Get a single answer
     * @param {string} answerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreOpsAnswersApiInterface
     */
    preOpsAnswersReadPreOpsAnswerRaw(requestParameters: PreOpsAnswersReadPreOpsAnswerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreOpsAnswer>>;

    /**
     * Returns the answer specified by the given ID.
     * Get a single answer
     */
    preOpsAnswersReadPreOpsAnswer(requestParameters: PreOpsAnswersReadPreOpsAnswerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreOpsAnswer>;

    /**
     * Creates request options for preOpsAnswersValidatePreOpsAnswerGroup without sending the request
     * @param {PreOpsAnswerGroupCreate} preOpsAnswerGroupCreate 
     * @throws {RequiredError}
     * @memberof PreOpsAnswersApiInterface
     */
    preOpsAnswersValidatePreOpsAnswerGroupRequestOpts(requestParameters: PreOpsAnswersValidatePreOpsAnswerGroupRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for a new answer group without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate an answer group
     * @param {PreOpsAnswerGroupCreate} preOpsAnswerGroupCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreOpsAnswersApiInterface
     */
    preOpsAnswersValidatePreOpsAnswerGroupRaw(requestParameters: PreOpsAnswersValidatePreOpsAnswerGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for a new answer group without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate an answer group
     */
    preOpsAnswersValidatePreOpsAnswerGroup(requestParameters: PreOpsAnswersValidatePreOpsAnswerGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class PreOpsAnswersApi extends runtime.BaseAPI implements PreOpsAnswersApiInterface {

    /**
     * Creates request options for preOpsAnswersCreatePreOpsAnswerGroup without sending the request
     */
    async preOpsAnswersCreatePreOpsAnswerGroupRequestOpts(requestParameters: PreOpsAnswersCreatePreOpsAnswerGroupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['preOpsAnswerGroupCreate'] == null) {
            throw new runtime.RequiredError(
                'preOpsAnswerGroupCreate',
                'Required parameter "preOpsAnswerGroupCreate" was null or undefined when calling preOpsAnswersCreatePreOpsAnswerGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pre_ops_answers/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PreOpsAnswerGroupCreateToJSON(requestParameters['preOpsAnswerGroupCreate']),
        };
    }

    /**
     * Create a new pre-ops answer group.
     * Create a pre-ops answer group
     */
    async preOpsAnswersCreatePreOpsAnswerGroupRaw(requestParameters: PreOpsAnswersCreatePreOpsAnswerGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PreOpsAnswer>>> {
        const requestOptions = await this.preOpsAnswersCreatePreOpsAnswerGroupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PreOpsAnswerFromJSON));
    }

    /**
     * Create a new pre-ops answer group.
     * Create a pre-ops answer group
     */
    async preOpsAnswersCreatePreOpsAnswerGroup(requestParameters: PreOpsAnswersCreatePreOpsAnswerGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PreOpsAnswer>> {
        const response = await this.preOpsAnswersCreatePreOpsAnswerGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for preOpsAnswersExportPreOpsAnswersList without sending the request
     */
    async preOpsAnswersExportPreOpsAnswersListRequestOpts(requestParameters: PreOpsAnswersExportPreOpsAnswersListRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['timezone'] == null) {
            throw new runtime.RequiredError(
                'timezone',
                'Required parameter "timezone" was null or undefined when calling preOpsAnswersExportPreOpsAnswersList().'
            );
        }

        if (requestParameters['exportType'] == null) {
            throw new runtime.RequiredError(
                'exportType',
                'Required parameter "exportType" was null or undefined when calling preOpsAnswersExportPreOpsAnswersList().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling preOpsAnswersExportPreOpsAnswersList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dateStart'] != null) {
            queryParameters['date_start'] = (requestParameters['dateStart'] as any).toISOString();
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['date_end'] = (requestParameters['dateEnd'] as any).toISOString();
        }

        if (requestParameters['timezone'] != null) {
            queryParameters['timezone'] = requestParameters['timezone'];
        }

        if (requestParameters['exportType'] != null) {
            queryParameters['export_type'] = requestParameters['exportType'];
        }

        if (requestParameters['choices'] != null) {
            queryParameters['choices'] = requestParameters['choices'];
        }

        if (requestParameters['vehicleIds'] != null) {
            queryParameters['vehicle_ids'] = requestParameters['vehicleIds'];
        }

        if (requestParameters['questionId'] != null) {
            queryParameters['question_id'] = requestParameters['questionId'];
        }

        if (requestParameters['answerGroupId'] != null) {
            queryParameters['answer_group_id'] = requestParameters['answerGroupId'];
        }

        if (requestParameters['checklistId'] != null) {
            queryParameters['checklist_id'] = requestParameters['checklistId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pre_ops_answers/export`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Exports all the answers present.  If `search` is specified, return values similar to the `label` field. In that case, `sortKey` will not have any effect. I.e. results will be sorted by similarity to the search term instead.  Optionally filter by answer choice, question ID, answer group ID, create date and checklist ID. The `date_start` parameter is inclusive, the `date_end` parameter is exclusive.
     * Export pre-ops answers as csv or xlsx
     */
    async preOpsAnswersExportPreOpsAnswersListRaw(requestParameters: PreOpsAnswersExportPreOpsAnswersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.preOpsAnswersExportPreOpsAnswersListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Exports all the answers present.  If `search` is specified, return values similar to the `label` field. In that case, `sortKey` will not have any effect. I.e. results will be sorted by similarity to the search term instead.  Optionally filter by answer choice, question ID, answer group ID, create date and checklist ID. The `date_start` parameter is inclusive, the `date_end` parameter is exclusive.
     * Export pre-ops answers as csv or xlsx
     */
    async preOpsAnswersExportPreOpsAnswersList(requestParameters: PreOpsAnswersExportPreOpsAnswersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.preOpsAnswersExportPreOpsAnswersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for preOpsAnswersListPreOpsAnswers without sending the request
     */
    async preOpsAnswersListPreOpsAnswersRequestOpts(requestParameters: PreOpsAnswersListPreOpsAnswersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling preOpsAnswersListPreOpsAnswers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dateStart'] != null) {
            queryParameters['date_start'] = (requestParameters['dateStart'] as any).toISOString();
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['date_end'] = (requestParameters['dateEnd'] as any).toISOString();
        }

        if (requestParameters['choices'] != null) {
            queryParameters['choices'] = requestParameters['choices'];
        }

        if (requestParameters['vehicleIds'] != null) {
            queryParameters['vehicle_ids'] = requestParameters['vehicleIds'];
        }

        if (requestParameters['questionId'] != null) {
            queryParameters['question_id'] = requestParameters['questionId'];
        }

        if (requestParameters['answerGroupId'] != null) {
            queryParameters['answer_group_id'] = requestParameters['answerGroupId'];
        }

        if (requestParameters['checklistId'] != null) {
            queryParameters['checklist_id'] = requestParameters['checklistId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pre_ops_answers/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the answers present.  If `search` is specified, return values similar to the `label` field. In that case, `sortKey` will not have any effect. I.e. results will be sorted by similarity to the search term instead.  Optionally filter by answer choice, question ID, answer group ID, create date, and checklist ID. The `date_start` parameter is inclusive, the `date_end` parameter is exclusive.
     * List pre-ops answers
     */
    async preOpsAnswersListPreOpsAnswersRaw(requestParameters: PreOpsAnswersListPreOpsAnswersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PreOpsAnswer>>> {
        const requestOptions = await this.preOpsAnswersListPreOpsAnswersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PreOpsAnswerFromJSON));
    }

    /**
     * Lists all the answers present.  If `search` is specified, return values similar to the `label` field. In that case, `sortKey` will not have any effect. I.e. results will be sorted by similarity to the search term instead.  Optionally filter by answer choice, question ID, answer group ID, create date, and checklist ID. The `date_start` parameter is inclusive, the `date_end` parameter is exclusive.
     * List pre-ops answers
     */
    async preOpsAnswersListPreOpsAnswers(requestParameters: PreOpsAnswersListPreOpsAnswersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PreOpsAnswer>> {
        const response = await this.preOpsAnswersListPreOpsAnswersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for preOpsAnswersListPreOpsAnswersMetadata without sending the request
     */
    async preOpsAnswersListPreOpsAnswersMetadataRequestOpts(requestParameters: PreOpsAnswersListPreOpsAnswersMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling preOpsAnswersListPreOpsAnswersMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dateStart'] != null) {
            queryParameters['date_start'] = (requestParameters['dateStart'] as any).toISOString();
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['date_end'] = (requestParameters['dateEnd'] as any).toISOString();
        }

        if (requestParameters['choices'] != null) {
            queryParameters['choices'] = requestParameters['choices'];
        }

        if (requestParameters['vehicleIds'] != null) {
            queryParameters['vehicle_ids'] = requestParameters['vehicleIds'];
        }

        if (requestParameters['questionId'] != null) {
            queryParameters['question_id'] = requestParameters['questionId'];
        }

        if (requestParameters['answerGroupId'] != null) {
            queryParameters['answer_group_id'] = requestParameters['answerGroupId'];
        }

        if (requestParameters['checklistId'] != null) {
            queryParameters['checklist_id'] = requestParameters['checklistId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pre_ops_answers/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * Pre-ops answer listing metadata
     */
    async preOpsAnswersListPreOpsAnswersMetadataRaw(requestParameters: PreOpsAnswersListPreOpsAnswersMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.preOpsAnswersListPreOpsAnswersMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * Pre-ops answer listing metadata
     */
    async preOpsAnswersListPreOpsAnswersMetadata(requestParameters: PreOpsAnswersListPreOpsAnswersMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.preOpsAnswersListPreOpsAnswersMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for preOpsAnswersReadPreOpsAnswer without sending the request
     */
    async preOpsAnswersReadPreOpsAnswerRequestOpts(requestParameters: PreOpsAnswersReadPreOpsAnswerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['answerId'] == null) {
            throw new runtime.RequiredError(
                'answerId',
                'Required parameter "answerId" was null or undefined when calling preOpsAnswersReadPreOpsAnswer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pre_ops_answers/{answer_id}`;
        urlPath = urlPath.replace('{answer_id}', encodeURIComponent(String(requestParameters['answerId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the answer specified by the given ID.
     * Get a single answer
     */
    async preOpsAnswersReadPreOpsAnswerRaw(requestParameters: PreOpsAnswersReadPreOpsAnswerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreOpsAnswer>> {
        const requestOptions = await this.preOpsAnswersReadPreOpsAnswerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PreOpsAnswerFromJSON(jsonValue));
    }

    /**
     * Returns the answer specified by the given ID.
     * Get a single answer
     */
    async preOpsAnswersReadPreOpsAnswer(requestParameters: PreOpsAnswersReadPreOpsAnswerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreOpsAnswer> {
        const response = await this.preOpsAnswersReadPreOpsAnswerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for preOpsAnswersValidatePreOpsAnswerGroup without sending the request
     */
    async preOpsAnswersValidatePreOpsAnswerGroupRequestOpts(requestParameters: PreOpsAnswersValidatePreOpsAnswerGroupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['preOpsAnswerGroupCreate'] == null) {
            throw new runtime.RequiredError(
                'preOpsAnswerGroupCreate',
                'Required parameter "preOpsAnswerGroupCreate" was null or undefined when calling preOpsAnswersValidatePreOpsAnswerGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pre_ops_answers/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PreOpsAnswerGroupCreateToJSON(requestParameters['preOpsAnswerGroupCreate']),
        };
    }

    /**
     * Validate data for a new answer group without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate an answer group
     */
    async preOpsAnswersValidatePreOpsAnswerGroupRaw(requestParameters: PreOpsAnswersValidatePreOpsAnswerGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.preOpsAnswersValidatePreOpsAnswerGroupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for a new answer group without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate an answer group
     */
    async preOpsAnswersValidatePreOpsAnswerGroup(requestParameters: PreOpsAnswersValidatePreOpsAnswerGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.preOpsAnswersValidatePreOpsAnswerGroupRaw(requestParameters, initOverrides);
    }

}

/**
  * @export
  * @enum {string}
  */
export enum PreOpsAnswersExportPreOpsAnswersListExportType {
    CSV = 'csv',
    XLSX = 'xlsx'
}
